import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import isVAT from '../util/vat';

const VATField = ({ value, onChange, name, label, style, disabled, needBelgianVAT, errorMessage = null, ...props }) => {
	const [intValue, setIntValue] = useState(value);

	const handleChange = (v) => {
		const value = isValid(v) || null;
		setIntValue(value || v);
		onChange({ target: { name, value }});
	};

	const isValid = v => {
		if(!v) return false;
		if(v.length < 2) return false;
		const specialCharactersRegex = /[.,/\-_]/g;
		const sanitizedVAT = v.replace(specialCharactersRegex, '').toUpperCase();
		const VATPrefix = v.substring(0, 2).toUpperCase();

		// Is VAT Valid?
		if (!isVAT(sanitizedVAT, VATPrefix)) {
			return false;
		}
		// Do we need a belgian VAT?
		if (needBelgianVAT && VATPrefix !== 'BE') return false;
		return sanitizedVAT;
	};

	const hasValue = !!(value || intValue);
	const showError = hasValue && !isValid(value || intValue);

	return (
		<>
			<TextField
				fullWidth
				variant='outlined'
				value={value || intValue || ''}
				onChange={({ target: { value }}) => handleChange(value)}
				error={showError}
				name={name}
				label={label}
				style={style}
				disabled={disabled}
				placeholder={'BE0000000000'}
				sx={{ marginBottom: errorMessage ? 0 : 2 }}
				{...props}
			/>
			{errorMessage && (
				<Typography 
					variant='body2' 
					color='error' 
					sx={{ 
						marginBottom: 2, 
						marginTop: 0,
						minHeight: '1.5em',
						visibility: showError ? 'visible' : 'hidden',
					}}
				>
					{errorMessage || '\u00A0'}
				</Typography>
			)}
		</>
	);
};

VATField.type = 'VATField';

export default VATField;
